export const PURCHASE_STATUS = {
  DRAFT: "DRAFT",
  PENDING_APPROVAL: "PENDING_APPROVAL",
  ERROR: "ERROR",
  PAID: "PAID",
  DELIVERED: "DELIVERED",
  REFUNDED: "REFUNDED",
};
